import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clients-login-required',
  templateUrl: './login-required.component.html',
  styleUrls: ['./login-required.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginRequiredComponent {}
